// extracted by mini-css-extract-plugin
module.exports = {"root":"AgreementModal_root__1JIKw","additionalInfo":"AgreementModal_additionalInfo__39Xqm"};